import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { RouteStyledLink, StyledLinkTheme } from '../../components/StyledLink/StyledLink';
import { TextCell } from '../../components/TextCell/TextCell';
import { MarketerProductsCellContainer } from '../../containers/MarketerProductsCellContainer/MarketerProductsCellContainer';
import { UrlHelpers } from '../../service/UrlHelpers';
import { GridCellProps, GridColumnDecl } from '../../typings/grid';
import { Marketer, MARKETERS_PREFIX } from '../../typings/marketers';

import * as keyset from './marketersList.i18n';

const i18n = i18nFactory(keyset);

export enum MarketersListColumnKeys {
    ID = 'client-id',
    LOGIN = 'login',
    FULL_NAME = 'full-name',
    PRODUCTS = 'products',
    MARKETER_LINK = 'marketer-link'
}

const WIDTH_ID = 150;
const WIDTH_LOGIN = 200;
const WIDTH_FULL_NAME = 200;
const WIDTH_PRODUCTS = 600;

const tableCellMarketerClientId: GridColumnDecl<Marketer> = {
    title: i18n('client-id'),
    key: MarketersListColumnKeys.ID,
    width: WIDTH_ID,
    isResizable: false,
    isSortable: true,
    fixed: true,
    flexGrow: 1,
    cellClass: 'marketers-vertically-centred',
    CellComponent: React.memo(({ rowData: item }: GridCellProps<Marketer>) => <div>{item.id}</div>)
};

const tableCellMarketerLogin: GridColumnDecl<Marketer> = {
    title: i18n('login'),
    key: MarketersListColumnKeys.LOGIN,
    width: WIDTH_LOGIN,
    isResizable: false,
    isSortable: true,
    cellClass: 'marketers-vertically-centred',
    flexGrow: 1,
    CellComponent: React.memo(({ rowData: item }: GridCellProps<Marketer>) => (
        <TextCell>
            <RouteStyledLink
                theme={StyledLinkTheme.blue}
                href={UrlHelpers.createNewDirectUrlPathByParams(MARKETERS_PREFIX, item.id)}
            >
                {item.login}
            </RouteStyledLink>
        </TextCell>
    ))
};

const tableCellMarketerFullName: GridColumnDecl<Marketer> = {
    title: i18n('full-name'),
    key: MarketersListColumnKeys.FULL_NAME,
    width: WIDTH_FULL_NAME,
    isResizable: false,
    isSortable: true,
    fixed: true,
    flexGrow: 2,
    cellClass: 'marketers-vertically-centred',
    CellComponent: React.memo(({ rowData: item }: GridCellProps<Marketer>) => <TextCell>{item.fullName}</TextCell>)
};

const tableCellMarketerProducts: GridColumnDecl<Marketer> = {
    title: i18n('products'),
    key: MarketersListColumnKeys.PRODUCTS,
    width: WIDTH_PRODUCTS,
    isResizable: false,
    isSortable: false,
    flexGrow: 5,
    cellClass: 'marketers-vertically-centred',
    CellComponent: React.memo(({ rowData: item }: GridCellProps<Marketer>) => (
        <MarketerProductsCellContainer products={item.ownProducts} />
    ))
};

export function getMarketersListItem(): GridColumnDecl<Marketer>[] {
    return [tableCellMarketerClientId, tableCellMarketerLogin, tableCellMarketerFullName, tableCellMarketerProducts];
}
